import { SettingsMediaImage } from "./data"

export type WpMediaImage = {
  altText: string | undefined
  fileUrl: string
};

export function loadImage(image: SettingsMediaImage): WpMediaImage {
  return {
    altText: image.alt,
    fileUrl: image.url,
  }
}
